module.exports = __webpack_public_path__ + "assets/icons/recycle.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/jobcategories/recycle.png
// module id = ./src/styles/icons/jobcategories/recycle.png
// module chunks = 0